// src/components/admin/AttributeModals/AttributeModals.jsx
import React, { useState } from 'react';
import './AttributeModals.css';

export const ColorModal = ({ onClose, onSubmit, initialData = null }) => {
  const [formData, setFormData] = useState(
    initialData || {
      value: '',
      label: '',
      hex: '#000000'
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="attr-modal-overlay" onClick={onClose}>
      <div className="attr-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="attr-modal-header">
          <h3>{initialData ? 'Modifier la couleur' : 'Ajouter une couleur'}</h3>
          <button className="attr-modal-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="attr-modal-form">
          <div className="attr-form-group">
            <label>Nom de la couleur *</label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData(prev => ({ 
                ...prev, 
                label: e.target.value,
                value: e.target.value 
              }))}
              required
              placeholder="Ex: Bleu marine"
            />
          </div>

          <div className="attr-form-group">
            <label>Code couleur (Hex) *</label>
            <div className="color-input-group">
              <input
                type="color"
                value={formData.hex}
                onChange={(e) => setFormData(prev => ({ ...prev, hex: e.target.value }))}
                className="color-picker"
              />
              <input
                type="text"
                value={formData.hex}
                onChange={(e) => setFormData(prev => ({ ...prev, hex: e.target.value }))}
                placeholder="#000000"
                pattern="^#[0-9A-Fa-f]{6}$"
                required
              />
            </div>
            <p className="attr-hint">Sélectionnez ou entrez le code hexadécimal</p>
          </div>

          <div className="attr-form-group">
            <label>Aperçu</label>
            <div className="color-preview" style={{ backgroundColor: formData.hex }}>
              <span>{formData.label || 'Couleur'}</span>
            </div>
          </div>

          <div className="attr-modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-submit">
              {initialData ? 'Modifier' : 'Ajouter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const MaterialModal = ({ onClose, onSubmit, initialData = null }) => {
  const [formData, setFormData] = useState(
    initialData || {
      value: '',
      label: '',
      category: 'Bois'
    }
  );

  const categories = ['Bois', 'Métal', 'Verre', 'Tissus', 'Synthétique', 'Autre'];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="attr-modal-overlay" onClick={onClose}>
      <div className="attr-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="attr-modal-header">
          <h3>{initialData ? 'Modifier le matériau' : 'Ajouter un matériau'}</h3>
          <button className="attr-modal-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="attr-modal-form">
          <div className="attr-form-group">
            <label>Nom du matériau *</label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData(prev => ({ 
                ...prev, 
                label: e.target.value,
                value: e.target.value 
              }))}
              required
              placeholder="Ex: Bois de chêne massif"
            />
          </div>

          <div className="attr-form-group">
            <label>Catégorie *</label>
            <select
              value={formData.category}
              onChange={(e) => setFormData(prev => ({ ...prev, category: e.target.value }))}
              required
            >
              {categories.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div className="attr-modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-submit">
              {initialData ? 'Modifier' : 'Ajouter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};